import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { FuelEntry, ListItem, RepositoryModal } from '../../shared'
import { FuelRecordsComponent } from './fuel-records.component'

@Component({
    templateUrl: './fuel-record.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class FuelRecordComponent extends RepositoryModal<FuelEntry> {
    fuelInMap: ListItem<string>[] = []
    fuelOutMap: ListItem<string>[] = []
    jobMap: ListItem<string>[] = []

    protected onInitialized() {
        const fuelRecordsController = this.editOptions.initializeParams as FuelRecordsComponent
        this.jobMap = fuelRecordsController.allJobs.orderByDescending(x => x.id).map(x => new ListItem(x.id, x.id + ' ' + x.name))

        for (const item of fuelRecordsController.allEquipment) {
            if (item.udFueler === 'Y') {
                this.fuelOutMap.push(new ListItem(item.equipment, item.equipment))
            } else if (item.fuelTypeIn !== 'N' && item.equipment[0] !== 'P') {
                this.fuelInMap.push(new ListItem(item.equipment, item.equipment))
            }
        }
    }
}
